import PriceRange from "./components/PriceRange";
import FiltersList from "./components/FiltersList";

import { FILTERS_LIST, FILTERS_VALUES } from "./gql/FiltersQueries";

export default {
  name: "filters",

  data() {
    return {
      filters: [],
      userFilters: {},
      skipFiltersQuery: true
    };
  },

  mounted() {
    this.skipFiltersQuery = false;
  },

  apollo: {
    filters: {
      query: FILTERS_LIST
    },

    userFilters: {
      query: FILTERS_VALUES,
      fetchPolicy: "no-cache",
      skip() {
        return this.skipFiltersQuery;
      },
      result({ data: { userFilters } }) {
        this.skipFiltersQuery = true;

        if (!userFilters)
          return;

        if (
          this.$store.state.filters.address &&
          this.$store.state.filters.address.placeId
        ) {
          userFilters.address.placeId = this.$store.state.filters.address.placeId;
        }

        if (this.$route.query.address)
          userFilters.address.placeId = JSON.parse(this.$route.query.address).placeId;
        if (this.$route.query.filters && this.$route.query.filters.length)
          userFilters.filters = JSON.parse(this.$route.query.filters);

        this.$store.commit("setFilters", userFilters);
      }
    }
  },

  computed: {
    priceRange() {
      if (this.filters && this.filters.price) {
        return this.filters.price;
      } else {
        return {};
      }
    },

    filtersList() {
      if (this.filters && this.filters.entities) {
        return this.filters.entities;
      } else {
        return [];
      }
    }
  },

  methods: {},

  components: {
    PriceRange,
    FiltersList
  }
};
